(function () {
  'use strict';

  if (window.PGHomePolishV33R2) return;
  window.PGHomePolishV33R2 = true;

  function placeShelfCue() {
    var shelf = document.querySelector('[data-pg-home-shelf]');
    if (!shelf) return;

    var railWrap = shelf.querySelector('.pg-home-shelf__rail-wrap');
    var cue = shelf.querySelector('.pg-swipe-cue--shelf');
    if (!railWrap || !cue) return;

    if (cue.dataset.pgV33R2 !== 'true') {
      var replacement = cue.cloneNode(true);
      replacement.dataset.pgV33R2 = 'true';
      replacement.classList.remove('is-dismissed');
      replacement.removeAttribute('aria-hidden');
      replacement.innerHTML = 'More favourites are hiding this way <span class="pg-swipe-cue__arrow" aria-hidden="true">&rarr;</span>';
      cue.replaceWith(replacement);
      cue = replacement;
    }

    if (railWrap.nextElementSibling !== cue) {
      railWrap.insertAdjacentElement('afterend', cue);
    }
  }

  function apply() {
    placeShelfCue();
  }

  function boot() {
    apply();
    [120, 400, 900, 1800].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(apply, 0);
  });
})();
